import LowHierarchySelection from './LowHierarchySelection';
export const FUNCTION_TYPE = 9;
export default class PermissionLowHierarchySelection extends LowHierarchySelection {
    constructor() {
        super({ nodeIsSelectable: () => true });
    }
    toggleNodeSelected(oldTreeState, nodeId, context) {
        const model = oldTreeState.models[nodeId];
        if (!model || model.type !== FUNCTION_TYPE)
            return oldTreeState;
        const isCurrentlySelected = this.nodeIsSelected(oldTreeState, nodeId);
        const newState = super.toggleNodeSelected(oldTreeState, nodeId, context);
        if (isCurrentlySelected) {
            const { parents, children } = oldTreeState;
            const selectionStatuses = { ...newState.selectionStatuses };
            const removedIds = new Set();
            let parentId = parents[nodeId];
            while (parentId) {
                const siblings = children[parentId] || [];
                const anyChildSelected = siblings.some(childId => childId in selectionStatuses);
                if (!anyChildSelected) {
                    delete selectionStatuses[parentId];
                    removedIds.add(String(parentId));
                    parentId = parents[parentId];
                }
                else {
                    break;
                }
            }
            const selection = newState.selection.filter((node) => !removedIds.has(String(node.id)));
            return { ...newState, selectionStatuses, selection };
        }
        return newState;
    }
}
